import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <CarouselSection />
        <IndexSection />
        <AppSection />
        <FAQSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <AboutSection />
        <CardsSection />
        <MediaSection />
        <CommentsSection />
        <TopicsSection />
      </main>
      <Footer />
    </div>
  );
}